import {createAction} from 'redux-actions';

export const OPEN_WINDOW = 'OPEN_WINDOW';
export const CLOSE_WINDOW = 'CLOSE_WINDOW';

export const openWindow = createAction(OPEN_WINDOW);
export const closeWindow = createAction(CLOSE_WINDOW);
